// extracted by mini-css-extract-plugin
export default {"text":"pageWork_text__bpKrh"};